var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/tabbar_camera_selected.002d16e3.png","uri@3x": __webpack_public_path__ + "static/media/tabbar_camera_selected.3c9e9347.png","uri@2x": __webpack_public_path__ + "static/media/tabbar_camera_selected.0437b26a.png",
    width: 24,
    height: 24
});